const { Baggage } = require('./lib/baggage');
const { TraceContext } = require('./lib/message-trace-context');
const { TraceContextSetter } = require('./lib/message-trace-context-setter');
const { MessageTracingSupport } = require('./lib/message-tracing-support');

module.exports.Baggage = Baggage;
module.exports.TraceContext = TraceContext;
module.exports.TraceContextSetter = TraceContextSetter;
module.exports.MessageTracingSupport = MessageTracingSupport;
